/* unplugin-vue-components disabled */import script from "./GoodInfoTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoodInfoTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./GoodInfoTableBlock.vue?vue&type=style&index=0&id=7ba021b4&scoped=true&lang=less"
import "./GoodInfoTableBlock.vue?vue&type=style&index=1&id=7ba021b4&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba021b4"]])

export default __exports__